var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState, useEffect } from 'react';
import { COLOR } from '../theme/colors';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
const LightTooltip = styled((_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx(Tooltip, Object.assign({}, props, { classes: { popper: className } })));
})(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: COLOR.textColor.primary,
        maxWidth: 238,
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '20px',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: COLOR.textColor.primary,
    },
}));
export const DashboardTooltip = (props) => {
    return (_jsx(LightTooltip, Object.assign({}, props, { children: props.children })));
};
export const OverflowTip = ({ children }) => {
    const [isOverflowed, setIsOverflow] = useState(false);
    const textElementRef = useRef();
    useEffect(() => {
        var _a, _b;
        if (textElementRef && textElementRef.current) {
            /*// @ts-ignore */
            setIsOverflow(((_a = textElementRef === null || textElementRef === void 0 ? void 0 : textElementRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) > ((_b = textElementRef === null || textElementRef === void 0 ? void 0 : textElementRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth));
        }
    }, []);
    return (_jsx(DashboardTooltip, Object.assign({ title: children, disableHoverListener: !isOverflowed, arrow: true }, { children: _jsx("div", Object.assign({ ref: textElementRef, style: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            } }, { children: children })) })));
};
